import { ServerConfig } from "@/config/config";
import { Fostplus } from "@/models/base/fostplus";
import { Axios } from "@/utils/axios";

class FostplusServiceClass {
	public readonly URL = `${ServerConfig.host}/fostplus`;

	public async fetchFostplusItemsByYear(year:number):Promise<Fostplus[]>{
		let result = await Axios.get(`${this.URL}/${year}`);
		return (result.data || []).map((i:number)=>new Fostplus(i));
	}

	public async setFostplusAmount(code:string, amount:number, year:number):Promise<Fostplus>{
		code = code.trim();
		let response = await Axios.post(`${this.URL}/${year}/${code}`, {Amount: amount});
		return new Fostplus(response.data);
	}

	public async deleteFostplusItem(code:string, year:number):Promise<void>{
		await Axios.delete(`${this.URL}/${year}/${code}`);
	}
}

export const FostplusService = new FostplusServiceClass();